import React, { useEffect, useState } from 'react';
import Wrapper from '../../../components/Wrapper';
import { useParams } from 'react-router-dom';
import ReportsTable from './ReportsTable';
import axiosInstance from '../../../utils/axios';

const FieldOfficerReports = () => {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const { data } = await axiosInstance.get(`/field-officer/reports/${id}`);
        setReports([...data]);
      } catch (err) {
        console.log('ERROR: ', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReports();
  }, [id]); 

  return (
    <Wrapper>
      <h1>Reports</h1>
      {isLoading ? (
        <div className="text-center py-4">Loading reports...</div>
      ) : (
        <ReportsTable data={reports} />
      )}
    </Wrapper>
  );
};

export default FieldOfficerReports;